<template>
  <div class="h-full">
    <el-row class="h-full w-full">
      <el-col :span="showControlPanel ? 18 : 24" class="h-full">
        <div ref="ysplayer" :class="[className, 'w-full', 'h-full']"></div>
      </el-col>
      <el-col
        :span="showControlPanel ? 6 : 0"
        class="h-full pl-10px"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="btnCont">
          <div>
            <div class="flex items-center">
              <div class="text-18px text-[#fff]">云台速：</div>
              <el-select
                popper-class="visualization-select-popper"
                v-model="ptzParam.turnSpeed"
                size="mini"
                placeholder="请选择云台速度"
                style="width: 70px;"
              >
                <el-option
                  v-for="item in speedOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="mt-10px">
              <el-switch
                @change="switchStatus"
                v-model="isHistory"
                inactive-text="实时播放"
                active-text="历史播放"
              >
              </el-switch>
            </div>
          </div>
          <div v-if="isHistory">
            <div class="mt-10px">
              <el-date-picker
                popper-class="monitor-picker-popper"
                size="mini"
                v-model="selectedDatetime"
                style="width: 100%;"
                type="datetimerange"
                placeholder="选择日期时间"
              ></el-date-picker>
            </div>
            <el-row class="mt-10px">
              <el-button plain @click="startPlay">开始回放</el-button>
              <el-button plain @click="stopPlay">停止回放</el-button>
            </el-row>
            <el-row class="mt-10px">
              <el-button
                v-if="isPausePlay"
                size="mini"
                plain
                icon="iconfont el-icon-video-play"
                @click="playControl('resumePlay')"
              ></el-button>
              <el-button
                v-if="!isPausePlay"
                @click="playControl('pausePlay')"
                size="mini"
                plain
                icon="iconfont el-icon-video-pause"
              ></el-button>
              <el-button
                @click="playControl('backPlay')"
                size="mini"
                plain
                icon="iconfont el-icon-d-arrow-left"
              ></el-button>
              <el-button
                @click="playControl('forwardPlay')"
                size="mini"
                plain
                icon="iconfont el-icon-d-arrow-right"
              ></el-button>
            </el-row>
          </div>
          <div
            class="directionCont ml-10px mt-40px  w-174px h-174px rounded-1/2 border-2"
            v-if="!isHistory"
          >
            <div class="m-t-10">
              <div class="tc">
                <img
                  class="controlImg controlImg_up cursor-pointer"
                  src="../images/video-monitor/arrows.png"
                  @mousedown="ctrlPtzBySelf('up')"
                  @mouseup="ctrlPtzBySelf('upEnd')"
                />
              </div>
              <div class="tc flex  justify-center">
                <img
                  class="controlImg cursor-pointer"
                  src="../images/video-monitor/arrows.png"
                  @mousedown="ctrlPtzBySelf('left')"
                  @mouseup="ctrlPtzBySelf('leftEnd')"
                />
                <img
                  class="controlImg controlImg_right  cursor-pointer"
                  src="../images/video-monitor/arrows.png"
                  @mousedown="ctrlPtzBySelf('right')"
                  @mouseup="ctrlPtzBySelf('rightEnd')"
                />
              </div>
              <div class="tc">
                <img
                  class="controlImg controlImg_down cursor-pointer"
                  src="../images/video-monitor/arrows.png"
                  @mousedown="ctrlPtzBySelf('down')"
                  @mouseup="ctrlPtzBySelf('downEnd')"
                />
              </div>
            </div>
          </div>
          <div class="flex mt-20px items-center">
            <span class="mr-5px text-18px text-[#fff]">云台变速调</span>
            <span
              class=" bg-[#B0D4FE19] display-block w-30px h-30px flex justify-center items-center mr-5px"
            >
              <img
                class="cursor-pointer"
                src="../../../../../assets/images/smartSecurity/放大.png"
                alt=""
              />
            </span>
            <span
              class=" bg-[#B0D4FE19] display-block w-30px h-30px flex justify-center items-center"
            >
              <img
                class="cursor-pointer"
                src="../../../../../assets/images/smartSecurity/缩小.png"
                alt=""
              />
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* 宇视——视频播放器 */
import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()

/* eslint-disable */
// 根据宇视v1.04文档获取的16进制指令数据
const directionCommandMap = {
  up: 0x0402, // 向上，十进制等于1026
  upEnd: 0x0401, // 向上停止
  right: 0x0502, // 向右，十进制等于1282
  rightEnd: 0x0501, // 向右停止
  down: 0x0404, // 向下，十进制等于1028
  downEnd: 0x0403, // 向下停止
  left: 0x0504, // 向左，十进制等于1284
  leftEnd: 0x0503, // 向左停止
}
export default {
  props: {
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
    // 是否显示云台和历史播放的操作面板;默认进来是实时播放模式，控制面板打开
    showControlPanel: {
      type: Boolean,
      default: true,
    },
    // 获取协议实例需要用到【pIid】,返回的内容包含有ip、端口、用户名、密码
    pIid: {
      type: String,
      defalut: '',
    },
  },
  data() {
    return {
      className: 'ysplayer',
      selectedDatetime: [
        this.dayjs(new Date()).format('YYYY/MM/DD 00:00:00'),
        this.dayjs(new Date()).format('YYYY/MM/DD HH:mm:ss'),
      ], // 回放开始、结束时间
      isPausePlay: false, // 是否暂停播放回放
      isHistory: false, // 播放模式；false = 实时播放；true = 历史播放
      streamType: 2, // 码流类型; 1 = 主码流；2 = 辅码流
      iframeObjId: '',
      ipAddress: '',
      username: '',
      password: '',
      port: '',
      currentCamera: '',
      recordStatusTimer: null, // 定时器，用于获取播放历史视频时的播放状态
      directionCommandMap,
      speedOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], // 云台转速，文档里写取0-9
      ptzParam: {
        turnSpeed: 3, // 云台转动
        angularSpeed: 5, // 转动角速度
        zoom: 0, // 云台监控放大倍数
      },
    }
  },
  async mounted() {
    // console.log('传入的2222', this.code, this.pIid)
    window.testLogin = this.login // todo-暂时挂载，调试完成后需删除
    const _this = this
    window.addEventListener('resize', (e) => {
      if (e.keyCode === 27 && _this.streamType === 1) {
        // 播放历史回放
        if (_this.isHistory) {
          _this.playHistory(_this.iframeObjId, _this.selectedDatetime[0], _this.selectedDatetime[1])
          return
        }

        // 1. 播放主码流还是辅码流 1为主码流，2为辅码流
        _this.streamType = 2
        // 2. 播放当前的监控
        _this.playLive()
      }
    })
    await this.getConfig()
  },
  beforeDestroy() {
    // 清除获取历史播放状态的定时器
    if (this.recordStatusTimer) {
      clearInterval(this.recordStatusTimer)
    }
  },
  methods: {
    // 切换播放模式
    switchStatus(res) {
      if (res) {
        // 历史播放
        this.playHistory(this.iframeObjId, this.selectedDatetime[0], this.selectedDatetime[1])
      } else {
        // 实时播放
        this.playLive()
      }
    },
    // 登录
    async login() {
      const _this = this
      const apiUrl = `http://${this.ipAddress}:${this.port}/VIID/login/v2`
      const requestOption = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
      }
      fetch(apiUrl, requestOption)
        .then((response) => {
          // console.log('第一次调登录接口的请求响应状态信息', response)
          if (response.status === 200) {
            return response.json()
          } else {
            throw new Error('网络请求失败')
          }
        })
        .then((res) => {
          // console.log('第一次调登录接口的响应结果', res)
          const accessCode = res.AccessCode
          const md2 = forge.md.md5.create() // md5
          const base64Username = window.btoa(this.username)
          const loginSignatureTemp = base64Username + accessCode + this.password
          md2.update(loginSignatureTemp) // md5
          const loginSignature = md2.digest().toHex() // md5
          // console.log('加密后的loginSignatureTemp:', loginSignature)
          const data = {
            UserName: this.username,
            AccessCode: accessCode,
            LoginSignature: loginSignature,
          }
          const requestOpion2 = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            body: JSON.stringify(data),
          }
          // console.log('第二次调用登录接口传的参数:', data)
          fetch(apiUrl, requestOpion2)
            .then((response) => {
              // console.log('第二次调登录接口的请求响应状态信息', response)
              if (response.status === 200) {
                return response.json()
              } else {
                throw new Error('网络请求失败')
              }
            })
            .then((r) => {
              // console.log('第二次调用登录接口的响应结果', r)
              const loginResult = r.ErrCode
              switch (
                loginResult // 判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
              ) {
                case 50004:
                  // console.log('密码错误')
                  break
                case 12351:
                  // console.log('用户不存在')
                  break
                case undefined:
                  window.playerToken = r.AccessToken
                  this.startCtr() // 开启云台操作
                  // console.log(loginResult, '登录成功11')
                  // 在使用https 的时候设置为https 代理端口号
                  const ishttps = document.location.protocol === 'https:'
                  if (ishttps) {
                    imosSdk.setLinkPort('7077')
                  }
                  const vmip = _this.ipAddress
                  imosSdk
                    .init(vmip, window.playerToken, 1, '/unv/imosSdk.html')
                    .then(() => {
                      // console.log(loginResult, '登录成功22')
                      // 设置后续事件回调
                      imosSdk.registerLiveMsg((result) => {
                        // console.log(result, '登录成功33')
                        if (result.Type === 'zoom' && result.Zoom === 1) {
                          // console.log(_this.iframeObjId, _this.code, '全屏')
                          // 播放器全屏 - 执行操作 - 惠州驾驶舱-数字工地
                          // 1. 切换到主码流 - 无论如何都需要执行 -
                          _this.streamType = 1 // 播放主码流还是辅码流 1为主码流，2为辅码流
                          // 2. 播放当前的监控

                          // 播放历史回放
                          if (_this.isHistory) {
                            _this.playHistory(
                              _this.iframeObjId,
                              _this.selectedDatetime[0],
                              _this.selectedDatetime[1]
                            )
                            return
                          }

                          // 播放实况
                          _this.playLive()
                        }
                        if (result.Type === 'zoom' && result.Zoom === 0) {
                          // console.log(_this.iframeObjId, _this.code, '退出全屏')

                          // 播放历史回放
                          if (_this.isHistory) {
                            _this.playHistory(
                              _this.iframeObjId,
                              _this.selectedDatetime[0],
                              _this.selectedDatetime[1]
                            )
                            return
                          }

                          // 取消播放器全屏 - 执行操作 - 惠州驾驶舱-数字工地
                          // 1. 缩小切换到辅码流 - 无论如何都需要执行 - 为了清晰度
                          _this.streamType = 2 // 播放主码流还是辅码流 1为主码流，2为辅码流
                          // 2. 播放当前的监控
                          _this.playLive()
                        }
                      })
                    })
                    .catch((err) => {
                      // console.log('调用失败')
                      // console.log(err)
                    })
                  break
                default:
              }
              _this.creatWindow()
            })
            .catch((e) => {
              // console.log('服务器连接异常')
              // console.log(e)
            })
        })
        .catch((error) => {
          // console.log('服务器连接异常123')
          // console.log(error)
        })
    },
    async getConfig() {
      const [err, res] = await iotDeviceProtocolInstanceApi.get(this.pIid)
      if (!err) {
        const parsedInfo = JSON.parse(res.jsonContent)
        this.ipAddress = parsedInfo.IP
        this.username = parsedInfo.UserName
        this.password = parsedInfo.PassWord
        this.port = parsedInfo.Port
        this.login()
      } else {
        this.ipAddress = ''
        this.username = ''
        this.password = ''
        this.port = ''
      }
    },
    creatWindow() {
      // console.log('进入了createWindow')
      if (!window.playerToken) {
        // console.log('请先登录')
        return
      }
      const iframeObj = imosSdk.createPanelWindow()
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        return
      }
      this.iframeObjId = iframeObj && iframeObj.id
      this.createSpeDiv(iframeObj)
    },
    createSpeDiv(iframeObj) {
      const videoDom = this.$refs.ysplayer
      // 如果存在子节点那么清除重新创建
      if (videoDom.hasChildNodes()) {
        videoDom.innerHTML = null
      }
      let divDom = document.createElement('div')
      divDom.style = 'height: 100%;'
      divDom.appendChild(iframeObj)
      videoDom.appendChild(divDom)
      divDom = null
      if (this.isHistory) {
        if (Array.isArray(this.selectedDatetime) && this.selectedDatetime.length === 0) {
          this.$message.error('历史回看参数未传递!')
          return
        }
        this.playHistory(iframeObj.id, this.selectedDatetime[0], this.selectedDatetime[1])
      } else {
        this.getCamera()
      }
    },
    getCamera() {
      if (this.code) {
        this.playLive()
      }
    },
    playControl(type) {
      // console.log('回放操作类型', type)
      // 暂停后的播放
      if (type === 'resumePlay') {
        this.isPausePlay = false
        this.switchPlayStatus(this.iframeObjId, true)
      }
      // 暂停
      if (type === 'pausePlay') {
        this.isPausePlay = true
        this.switchPlayStatus(this.iframeObjId, false)
      }
      // 快退,快进
      if (type === 'backPlay' || type === 'forwardPlay') {
        imosSdk.playStatus(this.iframeObjId, (result) => {
          // console.log('获取历史播放的播放状态', result)
          if (result.ErrCode === 0) {
            const currentTime = new Date(result.status.currentTime) // 回放当前时间
            // 每次点击快退、快退，以15秒为单位
            const startTime =
              type === 'backPlay' ? currentTime - 15 * 1000 : currentTime + 15 * 1000
            const startTimeFormat = this.dayjs(new Date(startTime)).format('YYYY/MM/DD HH:mm:ss')
            const endTime = this.dayjs(this.selectedDatetime[1]).format('YYYY/MM/DD HH:mm:ss')
            this.playHistory(this.iframeObjId, startTimeFormat, endTime)
          }
        })
      }
    },
    /**
     * @description 播放历史画面
     * @param iframeId 窗口id
     * @param startTime 开始时间
     * @param endTime 结束时间
     */
    playHistory(iframeId, startTime, endTime) {
      if (!window.playerToken) {
        // console.log('请先登录')
        return
      }
      if (!startTime) {
        this.$message.warning('请选择回放日期')
        return
      }
      // console.log(`开始播放历史画面${this.code}, ${startTime}-${endTime}`)
      /**
       * param1: 窗口id
       * param2: 摄像头编码
       * param3: 显示的标题名称
       * param4: 录像开始时间
       * param5: 录像结束时间
       * param6: 回调执行结果
       * param7 录像查询方式 1(前端录像) 2(中心录像) 3(先中心后前端)
       */
      imosSdk.playRecord(
        iframeId,
        this.code,
        this.code,
        new Date(startTime),
        new Date(endTime),
        (result) => {
          if (result.ErrCode === 0) {
            // console.log(`播放${this.code}历史回放${startTime}-${endTime}成功`)
            this.recordStatusTimer = setInterval(() => {
              this.getPlayStatus(iframeId)
            }, 30000)
          } else {
            this.$message.error(`播放失败：${result.ErrMsg}`)
          }
        },
        3
      )
    },
    // 开始回放
    startPlay() {
      if (Array.isArray(this.selectedDatetime) && this.selectedDatetime.length > 0) {
        const startTime = this.dayjs(new Date(this.selectedDatetime[0])).format(
          'YYYY/MM/DD HH:mm:ss'
        )
        const endTime = this.dayjs(new Date(this.selectedDatetime[1])).format('YYYY/MM/DD HH:mm:ss')
        this.playHistory(this.iframeObjId, startTime, endTime)
      }
    },
    // 停止回放
    stopPlay() {
      imosSdk.playStop(this.iframeObjId, (res) => {
        if (res.ErrCode === 0) {
          // console.log('停止回放执行成功')
        }
      })
    },
    // 回放暂停、继续播放
    switchPlayStatus(iframeID, canPlay) {
      imosSdk.switchPlayStatus(
        iframeID,
        (res) => {
          if (res.ErrCode === 0) {
            // console.log('操作成功')
          } else {
            // console.log(`操作失败${res.ErrMsg}`)
          }
        },
        canPlay
      )
    },
    // 获取播放状态
    getPlayStatus(iframeId) {
      imosSdk.playStatus(iframeId, (result) => {
        // console.log('获取历史播放的播放状态', result)
      })
    },
    // 实时播放
    playLive() {
      if (!window.playerToken) {
        // console.log('请先登录')
        return
      }
      // console.log('实时播放code', this.code)
      imosSdk.playLive(
        this.iframeObjId, // 播放窗格的Id
        this.code, // 摄像头编码
        this.code, // 需要显示的标题名称
        (e) => {
          // console.log('播放实时视频的回调结果', e)
        },
        this.streamType
      )
    },
    // 启动云台控制
    async startCtr() {
      const url = `http://${this.ipAddress}:${this.port}/VIID/ptz/start/${this.code}`
      const requestOption = {
        method: 'POST',
        headers: {
          Authorization: window.playerToken,
          'Content-Type': 'application/json; charset=utf8',
        },
      }
      fetch(url, requestOption)
        .then((response) => {
          // console.log('启动云台控制的请求响应信息', response)
          if (response.status === 200) {
            return response.json()
          } else {
            throw new Error('网络请求失败')
          }
        })
        .then((res) => {
          // console.log('启动云台控制的响应结果', res)
        })
        .catch((error) => {
          // console.log('开启云台控制错误')
          // console.log(error)
        })
    },
    // 发送云台控制指令
    async ctrlPtzBySelf(cmdId) {
      const url = `http://${this.ipAddress}:${this.port}/VIID/ptz/ctrl/${this.code}`
      const data = {
        PTZCmdID: this.directionCommandMap[cmdId],
        PTZCmdPara1: this.ptzParam.turnSpeed,
        PTZCmdPara2: this.ptzParam.angularSpeed,
        PTZCmdPara3: this.ptzParam.zoom,
      }
      const requestOption = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Authorization: window.playerToken,
        },
        body: JSON.stringify(data),
      }
      fetch(url, requestOption)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else {
            throw new Error('网络请求失败')
          }
        })
        .then((res) => {
          // console.log(res)
          if (res.ErrCode === 0) {
            // console.log('云台控制指令发送成功', res.ErrMsg)
          } else {
            // console.log('云台控制指令发送失败', res.ErrMsg)
          }
        })
        .catch((error) => {
          // console.log('服务器连接异常云台')
          // console.log(error)
        })
    },
  },
  watch: {
    code(val) {
      this.creatWindow()
    },
  },
}
</script>

<style scope lang="scss">
.imosSdk-video {
  width: 100% !important;
  height: 100% !important;
}

.btnCont {
  // width: 250px;
  // display: flex;
  align-items: center;
}

.controlImg {
  width: 30px;

  &_up {
    transform: rotate(90deg);
  }

  &_right {
    margin-left: 30px;
    transform: rotate(180deg);
  }

  &_down {
    transform: rotate(-90deg);
  }
}

.tc {
  text-align: center;
  text-align: -webkit-center;
}
</style>
